import { mainAxios } from "@/mainAxios";

export default {
  namespaced: true,
  state: {
    llamadas: [],
  },
  mutations: {
    setLlamadas(state, payload) {
      state.llamadas = payload;
    },
  },
  actions: {
    async getLlamadas({ commit }, payload) {
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      let { data } = await mainAxios.get(
        `v1/bradescard/lead/llamadas/${payload}`,
        config
      );

      const notShow = [
        "Enviado sin respuesta del cliente",
        "Envío fallido",
        "Lead ingresado erroneamente",
      ];

      const filteredLlamadas = data.filter(
        (item) => !notShow.includes(item.disposicion)
      );
      commit("setLlamadas", filteredLlamadas);
    },
  },
};
